export enum Claim {
  FullAccess = 1, // Полный доступ

  // Root menu
  Goods = 2, // Товары
  Feedbacks = 5, // Отзывы и сообщения
  WarehouseAndRemains = 6, // Склад и остатки
  Orders = 7, // Заказы
  Settings = 8, // Настройки
  Support = 25, // Поддержка

  // "Товары"
  Catalog = 3, // Каталог
  Categories = 4, // Категории
  MergeProducts = 18, // Объединение товаров
  ProductLabeling = 23, // Маркировка продукции

  // "Настройки"
  Logs = 9, // Логи
  Integrations = 10, // Интеграции
  Organizations = 11, // Организации
  Employees = 12, // Сотрудники
  Labels = 13, // Этикетки

  // "Заказы"
  OwnWarehouseFbs = 16, // Со своего склада FBS
  Supplies = 17, // Поставки

  // "Склад и остатки"
  Warehouses = 19, // Склады
  Stocks = 20, // Остатки
  HasAccessToRedistribution = 26, // Перераспределение остатков WB

  // "Поддержка"
  AdminSupport = 24, // Поддержка админ

  // Доп. доступы
  CanCancelFbsOrders = 14, // Может отменять заказы FBS
  CanDeleteProducts = 15, // Может удалять товары
  CanEnableDisableStockManagement = 21, // Может включать/отключать сервисы управления остатками
  CanAccessFinancialInfo = 22, // Имеет доступ к финансовой информации
}

export const ClaimsTreeMap = {
  [Claim.Goods]: [
    Claim.Catalog,
    Claim.Categories,
    Claim.MergeProducts,
    Claim.ProductLabeling,
  ],
  [Claim.Settings]: [
    Claim.Logs,
    Claim.Integrations,
    Claim.Organizations,
    Claim.Employees,
    Claim.Labels,
  ],
  [Claim.Orders]: [Claim.OwnWarehouseFbs, Claim.Supplies],
  [Claim.WarehouseAndRemains]: [
    Claim.Warehouses,
    Claim.Stocks,
    Claim.HasAccessToRedistribution,
  ],
  // [Claim.Support]: [Claim.AdminSupport],
};

export const additionalAccessClaims = [
  Claim.CanCancelFbsOrders,
  Claim.CanDeleteProducts,
  Claim.CanEnableDisableStockManagement,
  Claim.CanAccessFinancialInfo,
];

export const claimsLabels = {
  [Claim.Goods]: "Товары",
  [Claim.Catalog]: "Каталог",
  [Claim.Categories]: "Категории",
  [Claim.MergeProducts]: "Объединение товаров",
  [Claim.ProductLabeling]: "Маркировка продукции",

  [Claim.Feedbacks]: "Отзывы и сообщения",

  [Claim.Settings]: "Настройки",
  [Claim.Logs]: "Логи",
  [Claim.Integrations]: "Интеграции",
  [Claim.Organizations]: "Организации",
  [Claim.Employees]: "Сотрудники",
  [Claim.Labels]: "Этикетки",

  [Claim.Orders]: "Заказы",
  [Claim.OwnWarehouseFbs]: "Со своего склада FBS",
  [Claim.Supplies]: "Поставки",

  [Claim.WarehouseAndRemains]: "Склад и остатки",
  [Claim.Warehouses]: "Склады",
  [Claim.Stocks]: "Остатки",
  [Claim.HasAccessToRedistribution]: "Перераспределение остатков WB",

  [Claim.Support]: "Поддержка",
  [Claim.AdminSupport]: "Поддержка админ",

  [Claim.CanCancelFbsOrders]: "Может отменять заказы FBS",
  [Claim.CanDeleteProducts]: "Может удалять товары",
  [Claim.CanEnableDisableStockManagement]:
    "Может включать/отключать сервисы управления остатками",
  [Claim.CanAccessFinancialInfo]: "Имеет доступ к финансовой информации",
};

export const RootClaims: Set<Claim> = new Set(
  Object.keys(ClaimsTreeMap)
    .map(Number)
    .filter((c) => !isNaN(c)),
);

export const ClaimsParentsMap = Object.fromEntries(
  Object.entries(ClaimsTreeMap).flatMap(([parent, children]) =>
    children.map((child) => [+child, +parent]),
  ),
);
